export default __webpack_public_path__ + "static/media/icon-clear.2c03595e.svg";